export default __webpack_public_path__ + "static/tablet-ae9b81769a381cb57b31c3dcbb2c4683.webp";